export default "__VITE_ASSET__382f5944__"